import react, { Fragment } from "react";
import { Col, Row, Space, Button } from 'antd';
import image from '../assets/images/footer-light.webp'
import Logo from '../assets/images/Mr-Chap.png'
import { Link } from "react-router-dom";


const FooterImageStyle = {
    backgroundImage: `url(${image})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: "cover",
    backgroundPosition: "center center",

}

function Footer() {
    return (
        <Fragment>
            <footer className="mt-3" style={FooterImageStyle}>

                <Row>
                    <Col xs={{ span: 12 }} xl={{ span: 7 }} >
                        <Space style={{ display: "flex", alignContent: "center", listStyle: "none", height: "300px", justifyContent: "space-around" }}>
                            <ul style={{ listStyle: "none" }} className="fEstedad-bold">
                            <li className="mt-2">
                                    <Link className="text-black" to="/">
                                         خانه
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link className="text-black" to="/login-signup">
                                        ورود / عضویت
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link className="text-black" to="/about-us">
                                        درباره ی آقای چاپ
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link className="text-black" to="/contact-us">
                                    تماس با آقای چاپ
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link className="text-black" to="/terms-and-conditions">
                                    قوانین و مقررات
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link className="text-black" to="/faqs">
                                    سوالات متداول
                                    </Link>
                                </li>
                            </ul>
                        </Space>

                    </Col>
                    <Col xs={{ span: 12 }} xl={{ span: 7 }} align="center">
                        <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=724619&Code=EgfNPcVweMiT7hwvrNESFw6sgGy1Q1ZT'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=724619&Code=EgfNPcVweMiT7hwvrNESFw6sgGy1Q1ZT' alt='' style={{"cursor":"pointer", "marginTop":"75px"}} code='EgfNPcVweMiT7hwvrNESFw6sgGy1Q1ZT'/></a>
                    </Col>
                    <Col className="pt-2" xs={{ span: 24 }} xl={{ span: 10 }} align="center">

                        <img src={Logo} width={180} height={180}></img>
                        <br />
                        <p>
                            آقای چاپ، ارائه دهنده ی خدمات
                            چاپ طرح دلخواه روی محصولات
                        </p>
                        <Button style={{ width: "auto" }} type="primary" className="m-2 mt-0" size="large" shape="circle">
                            <i className="fa fa-telegram"></i>
                        </Button>
                        <Button style={{ width: "auto" }} type="primary" className="m-2 mt-0" size="large" shape="circle">
                            <i className="fa fa-instagram"></i>
                        </Button>
                        <Button style={{ width: "auto" }} type="primary" className="m-2 mt-0" size="large" shape="circle">
                            <i className="fa fa-whatsapp"></i>
                        </Button>
                    </Col>
                </Row>

            </footer>

        </Fragment>
    )
}


export default Footer